import { create } from "zustand";
import { persist } from "zustand/middleware";
import i18n, { Language } from "../i18n/i18n";

interface LanguageState {
  language: string;
  setLanguage: (lang: string) => Promise<unknown>;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      language: Language.KAZAKH_CYRILLIC,
      setLanguage: (lang: string) => {
        set({ language: lang });
        return i18n.changeLanguage(lang);
      },
    }),
    { name: "kitap-language" },
  ),
);
